import { type Moment } from 'moment'

export enum SeriesTypes {
  Primary = 'primary',
  Secondary = 'secondary',
  ThisPeriod = 'this_period',
  LastPeriod = 'last_period',
  Good = 'GOOD',
  Ok = 'OK',
  Bad = 'BAD',
}

export type DataVizData = DataVizMetrics | DataVizCharts

export interface DataVizMetrics {
  type: 'metrics'
  data: {
    metrics: MetricsData[]
    title_key?: string
    action_key?: string
  }
}

export interface DataVizCharts {
  type: 'charts'
  data: {
    charts: ChartsData[]
    title_key?: string
    action_key?: string
    time_range: TimeRange
    chart_downloadable?: boolean
  }
}

export type MetricsData = { data: MetricData; type: 'metric' }
export type ChartsData = LineChartData | BarChartData

export interface MetricData {
  data_type: 'seconds' | 'percent' | 'currency' | 'number'
  desired_direction: 'positive' | 'negative' | 'neutral'
  last_period: string | number | null
  this_period: string | number | null
  title_key: string
  note: string | null
}

export interface ChartCoordinates {
  x: string
  y: string | number | null
}

export interface LineChartData extends BaseChartData {
  type: 'line_chart'
}

export interface BarChartData extends BaseChartData {
  type: 'bar_chart'
}

interface BaseChartData {
  data_type: 'currency' | 'number' | 'percent'
  title_key: string
  data: ChartCoordinates[][]
  series: ChartSeries[]
}

export interface ChartSeries {
  label: string
  type: SeriesTypes
}

export interface TimeRange {
  this_period: {
    start: string
    end: string
  }
  last_period?: {
    start: string
    end: string
  }
}

export interface Datum {
  x: number
  y: number | null
}

export enum PastDateRangeOption {
  Yesterday = 'yesterday',
  LastWeek = 'last_week',
  LastMonth = 'last_month',
  Last90Days = 'last_90_days',
  Custom = 'custom',
}

enum TodayDateRangeOption {
  Today = 'today',
}

export const DateRangeOption = {
  ...TodayDateRangeOption,
  ...PastDateRangeOption,
}

export type DateRangeOption = TodayDateRangeOption | PastDateRangeOption

export interface ChartDomain {
  x: [number, number]
  y: [number, number]
}

export interface SeriesDatumType {
  x: Moment
  y: number
}

export type SeriesData = SeriesDatumType[]

export interface GroupedSeriesData {
  type: SeriesTypes
  data: SeriesData
}
